<section class="cm-channel" [attr.data-channel-id]="contentId()">
  @if (store.status() === "loading") {
    <div class="cm-channel__loading">
      @for (item of [0, 1, 2]; track item) {
        <claas-content-skeleton />
      }
    </div>
  } @else if (localized() && store.notFound()) {
    <div class="cm-channel__fallback" role="status">
      <strong>Page not found.</strong>
    </div>
  } @else if (store.isReady()) {
    @for (placement of store.placements(); track placement.name) {
      @if (placement.items.length) {
        <div
          class="cm-placement"
          [class]="'cm-placement--' + placement.name"
          [attr.data-placement]="placement.name"
        >
          @for (stub of placement.items; track stub.id) {
            <claas-content-item [stub]="stub" />
          }
        </div>
      }
    }
  }
</section>
